import React, { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { createPortal } from 'react-dom';
import ObliqueIcon from '@/components/icons/ObliqueIcon';

const AgentMenu = ({ isCollapsed }) => {
    const [isOpen, setIsOpen] = useState(false);
    const buttonRef = useRef(null);
    const menuRef = useRef(null);
    const [coords, setCoords] = useState({ top: 0, left: 0 });

    const updatePosition = () => {
        if (buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            setCoords({ 
                top: rect.top - 180, // Position above the button
                left: rect.right + 12 
            });
        }
    };

    useEffect(() => {
        if (isOpen) {
            updatePosition();
            const handleClickOutside = (e) => {
                if (menuRef.current && !menuRef.current.contains(e.target) && !buttonRef.current.contains(e.target)) {
                    setIsOpen(false);
                }
            };
            document.addEventListener('mousedown', handleClickOutside);
            window.addEventListener('resize', updatePosition);
            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
                window.removeEventListener('resize', updatePosition);
            };
        }
    }, [isOpen]);

    const MenuContent = (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    ref={menuRef}
                    initial={{ opacity: 0, x: -10, scale: 0.95 }}
                    animate={{ opacity: 1, x: 0, scale: 1 }}
                    exit={{ opacity: 0, x: -10, scale: 0.95 }}
                    transition={{ duration: 0.15, ease: 'easeOut' }}
                    style={{
                        position: 'fixed',
                        top: coords.top,
                        left: coords.left,
                        width: '240px',
                        background: '#2d2d2d',
                        borderRadius: '12px',
                        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.24)',
                        zIndex: 9999,
                        padding: '16px 12px',
                        color: 'white',
                        fontFamily: 'Inter, sans-serif'
                    }}
                >
                    <div style={{ fontSize: '16px', fontWeight: '600', marginBottom: '16px', padding: '0 8px' }}>
                        Agents
                    </div>
                    
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                        <button className="agent-menu-item" style={menuItemStyle}>
                            <span>Agent Hub</span>
                            <span style={betaBadgeStyle}>Beta</span>
                        </button>
                        <button className="agent-menu-item" style={menuItemStyle}>
                            <span>Agent Inbox</span>
                            <span style={betaBadgeStyle}>Beta</span>
                        </button>
                        <button className="agent-menu-item" style={menuItemStyle}>
                            <span>Context</span>
                            <span style={newBadgeStyle}>New</span>
                        </button>
                        
                        <div style={{ height: '1px', background: 'rgba(255,255,255,0.1)', margin: '8px 0' }} />
                        
                        <button className="agent-menu-item" style={menuItemStyle}>
                            <span>Agent Marketplace</span>
                        </button>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );

    return (
        <>
            <button
                ref={buttonRef}
                onClick={() => setIsOpen(!isOpen)}
                style={{
                    flex: isCollapsed ? 'none' : 1,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    padding: '8px 12px', borderRadius: '8px',
                    background: isOpen ? 'var(--bg-muted)' : 'transparent', 
                    border: 'none', cursor: 'pointer',
                    color: '#8b5cf6', transition: 'background 0.15s',
                    fontSize: '13px', fontWeight: '600', gap: '8px',
                    width: isCollapsed ? '32px' : 'auto',
                    height: isCollapsed ? '32px' : 'auto'
                }}
                className="hover-bg-muted"
                title="Agents"
            >
                <ObliqueIcon name="smart_toy" size={18} style={{ flexShrink: 0 }} />
                {!isCollapsed && <span>Agents</span>}
            </button>
            {createPortal(MenuContent, document.body)}
            
            <style>{`
                .agent-menu-item {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width: 100%;
                    padding: 8px;
                    background: transparent;
                    border: none;
                    color: rgba(255, 255, 255, 0.9);
                    font-size: 14px;
                    cursor: pointer;
                    border-radius: 6px;
                    transition: background 0.1s;
                }
                .agent-menu-item:hover {
                    background: rgba(255, 255, 255, 0.1);
                }
            `}</style>
        </>
    );
};

const menuItemStyle = {
    // Styles handled by CSS class for hover states
};

const betaBadgeStyle = {
    background: '#7c3aed',
    color: 'white',
    fontSize: '11px',
    fontWeight: '600',
    padding: '2px 6px',
    borderRadius: '12px'
};

const newBadgeStyle = {
    background: '#059669',
    color: 'white',
    fontSize: '11px',
    fontWeight: '600',
    padding: '2px 6px',
    borderRadius: '12px'
};

export default AgentMenu;
